import styled from "styled-components"

const GalerieTitle = styled.h1`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`

export { GalerieTitle }
